export class UpdateKeyboardSettingsAction {
    constructor(settings) {
        this.name = 'UpdateKeyboardSettings';
        this.isDeviceAction = false;
        this.data = settings;
    }
}
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiVXBkYXRlS2V5Ym9hcmRTZXR0aW5nc0FjdGlvbi5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uLy4uL3NyYy9saWIvbW9kZWxzL2FjdGlvbnMvVXBkYXRlS2V5Ym9hcmRTZXR0aW5nc0FjdGlvbi50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFZQSxNQUFNLE9BQU8sNEJBQTRCO0lBS3ZDLFlBQVksUUFBMEI7UUFKdEIsU0FBSSxHQUFHLHdCQUF3QixDQUFDO1FBQ2hDLG1CQUFjLEdBQUcsS0FBSyxDQUFDO1FBSXJDLElBQUksQ0FBQyxJQUFJLEdBQUcsUUFBUSxDQUFDO0lBQ3ZCLENBQUM7Q0FDRiJ9